import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactPlayer from "react-player";
import { useDispatch, useSelector } from "react-redux";
import { GetSingleCourse, BuyACourse } from "../redux/actions/CourseAction";
import Loder from "../components/loder";
import VideoJS from "../components/VideoPlayer";
import unsplash from "../assets/unsplash.png"
import razorpayPaymentHelper from "../helpers/RazorpayPaymentHelper";

const Course = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const User = useSelector((state) => state.UserReducer.user);
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const courseId = new URLSearchParams(search).get("courseId");

  const [fetchingCourse, setFetchingCourse] = useState(false);
  const [course, setCourse] = useState();
  const [courseDetails, setCourseDetails] = useState();
  const [loader, setLoader] = useState(false);
  const [courseVideos, setCourseVideos] = useState();
  const [currentVideo, setCurrentVideo] = useState("");
  const [currentTitle, setCurrentTitle] = useState();
  const [videoJsOptions, setVideoOption] = useState({
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [{
      src: currentVideo,
      type: currentVideo?.toString().match(/^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/) ? "video/youtube" : "video/mp4"

    }]
  });
  const [loadVideo, setLoadVideo] = useState(false);

  const playerRef = React.useRef(null);

  useEffect(() => {
    if (User) {
      setFetchingCourse(true);
      const data = {
        courseId: courseId,
        learnerId: User._id,
        page: 1,
        limit: 10,
      };

      const onSuccess = (data) => {
       
        setCourse(data);
        setCourseDetails(data.courseData);
        setCourseVideos(data.courseVideos);
        setCurrentVideo(data.courseVideos[0].videoLink)
        setCurrentTitle(data.courseVideos[0].videoTitle)
        setFetchingCourse(false);
      };

      const onError = (error) => {
      
        setFetchingCourse(false);
      };

      dispatch(GetSingleCourse(data, onSuccess, onError));
    }
  }, [User]);

  useEffect(() => {
    if (currentVideo) {
      setVideoOption({
        autoplay: false,
        controls: true,
        responsive: true,
        fluid: true,
        height: "10px",
        sources: [{
          src: currentVideo,
          type: currentVideo.toString().match(/^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/) ? "video/youtube" : "video/mp4"

        }]
      })
    }
  }, [currentVideo])

  // useEffect(() => {
  //   // setCurrentVideo(courseVideos[0].videoLink)
  //   console.log(courseVideos[0].videoLink)
  // },[])
  console.log(currentVideo)

  // const videoJsOptions = { // lookup the options in the docs for more options
  //   autoplay: true,
  //   controls: true,
  //   responsive: true,
  //   fluid: true,
  //   techOrder:["youtube"],
  //   sources: [{
  //     src: currentVideo,
  //     type: "video/youtube"
  //   }]
  // }

  // const videoJsOptions = {
  //   autoplay: "muted",
  //   controls: true,
  //   responsive: true,
  //   fluid: true,
  //   sources: [
  //     {
  //       src: "https://www.youtube.com/watch?v=aLewqwPfkBE&ab_channel=SMANTX",
  //       type: "video/youtube"
  //     }
  //   ]
  // };

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // you can handle player events here
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      console.log('player will dispose');
    });
  };

  // const changePlayerOptions = () => {
  //   // you can update the player through the Video.js player instance
  //   if (!playerRef.current) {
  //     return;
  //   }
  //   // [update player through instance's api]
  //   playerRef.current.src([{src: 'http://ex.com/video.mp4', type: 'video/mp4'}]);
  //   playerRef.current.autoplay(false);
  // };
  const handleCurrentVideo = (url, title) => {
    setLoadVideo(true)
    setCurrentVideo(url)
    setCurrentTitle(title)

    setTimeout(() => {
      setLoadVideo(false)
    }, 500);
  }

  const handleBuy = () => {
    // e.preventDefault();
    setLoader(true)

    const userCurrency = time_zone.country === "IN" ? "INR" : "USD";
    const courseAmount = time_zone.country === "IN" ? courseDetails.coursePrice : courseDetails.coursePrice;

    const data = {
      amount: courseAmount,
      payment_capture: 1,
      currency: userCurrency,
      notes: {
        Name: User.name,
        Number: User.phoneNumber,
        Email: User.email,
        paymentDetails: "Course purchase",
      },
      txndesc: "Course payment",
    };


    const onSuccess = (rzpRes) => {
      console.log("Payment handler on success block")
      setLoader(false)
      const courseData = {
        courseId: courseDetails._id,
        amountPaid: courseDetails.coursePrice,
        learnerId: User._id
      }
      const onBuySuccess = (res) => {
       
        window.location.reload();
      }

      const onBuyError = (err) => {
        setLoader(false)
   
      }
      dispatch(BuyACourse(courseData, onBuySuccess, onBuyError)
      );
    };

    const modalClose = () => {
      setLoader(false);
    };
    if (courseAmount > 0) { razorpayPaymentHelper(data, onSuccess, modalClose); }
    
    // else {
    //   setLoader(false)
    //   const courseData = {
    //     courseId: courseDetails._id,
    //     amountPaid: courseDetails.coursePrice,
    //     learnerId: User._id
    //   }
    //   const onBuySuccess = (res) => {
    //     console.log(res)
    //     window.location.reload();
    //   }

    //   const onBuyError = (err) => {
    //     setLoader(false)
    //     console.log(err)
    //   }
    //   dispatch(BuyACourse(courseData, onBuySuccess, onBuyError)
    //   );
    // }
  }

  return (
    <div className="course">
      {!fetchingCourse ? (
        <>
          <div className="top-card">
            <div className="unsplash">

              <img src={courseDetails ? courseDetails.thumbnail :""} alt="cover" width="100%" height="100%" style={{ borderRadius: "19px 0 19px 0" }} />

            </div>
            <div className="course-title">{courseDetails?.courseName}</div>
            <div className="small-text mt-4">Brought to you by</div>
            <div className="d-flex mt-4">
              <div>
                <img src={courseDetails?.teacherImage} height="40px" width="40px" style={{ borderRadius: "50%" }} alt="teacher image" />
              </div>
              <div className=" ml-2">
                <div className="teacher-name ">{courseDetails?.teacherName}</div>
                <div className="teacher-desc descTeacher">{courseDetails?.teacherDesc}</div>
              </div>
            </div>
            <div className=" mt-4 d-flex">
              <div className="lectures">{courseVideos?.length} lectures</div>
              {/* <div className="lectures">Ratings</div> */}
            </div>
            <div className="mt-4">
              {course?.hasUserBought === true ?
                <p style={{ color: "green" }}>You have purchased this course</p> :
                <button className="buy-btn" onClick={handleBuy}>{loader ? "loading" : (courseDetails?.coursePrice === 0? "Free" : `Buy Course - ₹ ${courseDetails?.coursePrice}`)}</button>
              }

            </div>
          </div>

          <div className="player-container">
            <div className="main-player">
              {
                !loadVideo ?
                  <div className="player">
                    <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
                  </div>
                  : "Loading..."
              }

              <div className="name ">{currentTitle}</div>
              <div className="desc">{courseDetails?.courseName}</div>
              <hr />
              <div className="abt">
                <div className="name ">About this course</div>
                <div className="desc">{courseDetails?.courseDesc}</div>
                <hr />
                <div className="name ">About the instructor</div>
                <div className="desc">{courseDetails?.teacherDesc}</div>
              </div>
            </div>

            <div className="playlist">
              <div className="name pt-4">Videos</div>
              <hr />
              <div className="list-container">
                {courseVideos?.map((data) => {
                  return (
                    <div className="list-item mb-4">
                      <div className="list-title">{data.videoNumber}. {data.videoTitle}</div>
                      <div className="d-flex">
                        <div className={data.videoLink === currentVideo?"currentPlaying":"thumb"}>
                          <img src={data.thumbnail} height="150px" alt="thumbnail" />
                        </div>
                        {data.isVideoFree === false && course?.hasUserBought === false ?

                          <div className="lock">
                            <i class="fas fa-lock"></i> Buy this course to unlock the video
                          </div>
                          :
                          <div
                            onClick={() => handleCurrentVideo(data.videoLink, data.videoTitle)}
                            className="start">
                            <i class="fas fa-play"></i> Start
                          </div>}

                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="m-5">
          <Loder />
        </div>
      )}
    </div>
  );
};

export default Course;
